/*
 * @Date: 2021-06-29 09:45:31
 * @Autor: liaosir
 * @Description: 首页 --- 效率状态面板
 */
import React, { useEffect, useRef } from 'react';
import $i18n from 'panda-i18n';
import { useSetState } from 'ahooks';
import { AreaChart } from 'bizcharts';
import { getWarehouseCode, vToLabel } from '@/utils';
import { getEffect } from './index.services';
import { State, ListProps, ResProps } from './index.interface';
import { Loading } from '@fpxfd/next';
import { EFFECT_TYPE } from '@/const';

const EfficiencyBoard = () => {
  const [state, setState] = useSetState<State>({
    effciencyList: [],
    loading: false,
    numList: [],
  });

  const effciencyRef: React.MutableRefObject<ListProps[]> = useRef([]);
  effciencyRef.current = state.effciencyList;
  const loadRef: React.MutableRefObject<boolean> = useRef(false);
  loadRef.current = state.loading;
  const numListRef: React.MutableRefObject<[]> = useRef([]);
  numListRef.current = state.numList;

  const initDatas = () => {
    const d: ListProps[] = [];
    !effciencyRef.current?.length && setState({ loading: true });

    const arr: [] = [];
    getEffect({ warehouseCode: getWarehouseCode() })
      .then((res) => {
        const result = [...res];
        result &&
          EFFECT_TYPE?.forEach((e) => {
            const current: ResProps = result.filter((x: ResProps) => x.operationLink === e.value)[0];
            if (arr.indexOf(current?.pcsNum) === -1) {
              arr.push(current.pcsNum);
            } else if (arr.indexOf(current?.expectEmpNum) === -1) {
              arr.push(current.expectEmpNum);
            }

            d.push({
              name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
              type: vToLabel(EFFECT_TYPE, current?.operationLink),
              person: current?.pcsNum,
            });

            d.push({
              name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
              type: vToLabel(EFFECT_TYPE, current?.operationLink),
              person: current?.expectEmpNum,
            });
          });
      })
      .finally(() => {
        if (JSON.stringify(d) !== JSON.stringify(effciencyRef.current)) {
          setState({
            effciencyList: d,
            loading: false,
            numList: arr,
          });
        }
      });
  };

  useEffect(() => {
    initDatas();
    const timer = setInterval(() => {
      initDatas();
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const cellCount = () => {
    const max = Math.max.apply(null, numListRef.current);
    if (numListRef.current.length > 8) {
      return 8;
    } else if (max > 1000 && numListRef.current.length < 4) {
      return 4;
    } else return numListRef.current.length;
  };

  return (
    <Loading visible={loadRef.current}>
      <AreaChart
        data={state.effciencyList}
        title={{
          visible: true,
          text: $i18n.get({ id: 'EfficiencyStatus.four_px', dm: '效率状态' }),
        }}
        xField={'type'}
        yField={'person'}
        xAxis={{
          line: {
            visible: false,
          },
          label: {
            autoRotate: true,
            autoHide: false,
          },
          tickLine: {
            visible: false,
          },
        }}
        yAxis={{
          tickLine: {
            visible: false,
          },

          line: {
            visible: false,
          },
          tickCount: cellCount(),
        }}
        autoFit
        padding="auto"
        renderer="svg"
        seriesField="name"
        color={['#3561CC', '#3ACFC4']}
      />
    </Loading>
  );
};

export default EfficiencyBoard;
